"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _animations = require("@qc-modules/animations");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _navItem = _interopRequireDefault(require("./nav-item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ScrollWrapper = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "sticky-nav__ScrollWrapper",
  componentId: "sc-1akfdxd-0"
})(["overflow-y:hidden;overflow-x:auto;-webkit-overflow-scrolling:touch;&::-webkit-scrollbar{display:none;}scrollbar-width:none;-ms-overflow-style:none;bottom:-24px;margin:0 auto;position:relative;font-size:0;white-space:nowrap;&:before,&:after{content:\" \";display:inline-block;width:24px;height:100%;flex:1 0 24px;}"]);
var propTypes = {
  /** A string of active tab */
  activeTab: _propTypes.string,

  /** Array holding an object for each tab's content */
  items: (0, _propTypes.arrayOf)(_propTypes.object),

  /** Callback to be called when tab is clicked */
  onTabClick: _propTypes.func,

  /** Boolean value to represent whether the nav bar has reached the top or not */
  sticky: _propTypes.bool,

  /** title of the nav */
  title: _propTypes.string
};

var StickyNavContainer = function StickyNavContainer(_ref) {
  var activeTab = _ref.activeTab,
      items = _ref.items,
      _onTabClick = _ref.onTabClick,
      sticky = _ref.sticky,
      title = _ref.title;

  var _useState = (0, _react.useState)({
    animating: false,
    currentIndex: 0
  }),
      _useState$ = _useState[0],
      animating = _useState$.animating,
      currentIndex = _useState$.currentIndex,
      setState = _useState[1];

  var updateAnimation = (0, _react.useCallback)(function (status) {
    return setState(function (_ref2) {
      var currentIndex = _ref2.currentIndex;
      return {
        animating: status,
        currentIndex: currentIndex
      };
    });
  }, // eslint-disable-line no-shadow
  []);
  var scrollValue = (0, _react.useMemo)(function () {
    var index = (0, _ramda.findIndex)((0, _ramda.propEq)("path", activeTab), items);

    if (index !== currentIndex) {
      setState({
        animating: true,
        currentIndex: index
      });
    }

    return index / (items.length - 1);
  }, [activeTab, items, currentIndex]);
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    bottom: 0,
    "data-test-id": "modules-sticky-nav",
    height: "78px",
    left: 0,
    overflow: "hidden" // Hide overlap padding in scroller to hide scroll bars on IOS
    ,
    width: 1
  }, !sticky && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "text-light-grey",
    fontSize: 1,
    lineHeight: "13px",
    mb: 1,
    tag: "div",
    textAlign: "center"
  }, title), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "flex-end",
    borderBottom: "1px solid",
    borderBottomColor: "gray",
    height: "57px",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_animations.ScrollTo, {
    allowScrollX: true,
    allowScrollY: false,
    animating: animating,
    scrollByPercentage: true,
    scrollX: scrollValue,
    tag: ScrollWrapper,
    updateAnimation: updateAnimation
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    display: "inline-block",
    pb: 3
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    justifyContent: "flex-start",
    py: 2,
    width: ["auto", "auto", 1]
  }, (0, _ramda.map)(function (_ref3) {
    var id = _ref3.id,
        path = _ref3.path,
        text = _ref3.text;
    return /*#__PURE__*/_react["default"].createElement(_navItem["default"], {
      key: id,
      isActive: path === activeTab,
      onTabClick: function onTabClick(event) {
        return _onTabClick({
          event: event,
          id: id,
          path: path,
          text: text
        });
      },
      path: path,
      text: text
    });
  }, items))))));
};

StickyNavContainer.propTypes = propTypes;
StickyNavContainer.displayName = "Modules.StickyNavContainer";
var _default = StickyNavContainer;
exports["default"] = _default;